import { Modal } from '@app/components/various/Modal';
import { fetchMarketsRequest } from '@app/ducks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { CreateAccountForm } from './CreateAccountForm';
import { CreateAccountFormValue } from './CreateAccountFormContent';
import { CreateAccountFormSkeleton } from './CreateAccountFormSkeleton';
import { CreateAccountModalContextProvider } from './CreateAccountModalContext';

interface CreateAccountModalBaseSharedProps {
  onSuccess: () => void;
  isOpen: boolean;
  isLoading?: boolean;
  onClose: VoidFunction;
  createSource?: 'lookbook';
  accountRequestId?: string;
  formDefaultValues?: Partial<CreateAccountFormValue>;
}

interface CreateAccountModalWithSelectionProps extends CreateAccountModalBaseSharedProps {
  shouldCreateSelection: true;
  products: string[];
  deliveryWindows: string[];
}

interface CreateAccountModalWithoutSelectionProps extends CreateAccountModalBaseSharedProps {
  shouldCreateSelection?: false;
  products?: never;
  deliveryWindows?: never;
}

type CreateAccountModalProps = CreateAccountModalWithSelectionProps | CreateAccountModalWithoutSelectionProps;

export const CreateAccountModal = ({
  isOpen,
  isLoading = false,
  accountRequestId,
  onClose,
  onSuccess,
  shouldCreateSelection = false,
  deliveryWindows,
  products,
  createSource,
  formDefaultValues,
}: CreateAccountModalProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['accounts']);

  React.useEffect(() => {
    dispatch(fetchMarketsRequest());
  }, [dispatch]);

  return (
    <CreateAccountModalContextProvider
      products={products}
      deliveryWindows={deliveryWindows}
      shouldCreateSelection={shouldCreateSelection}
      formDefaultValues={formDefaultValues}
      accountRequestId={accountRequestId}
    >
      <Modal isOpen={isOpen} title={t('accounts:create_new_account')} description={t('accounts:create_new_account_hint')} onClose={onClose}>
        {isLoading ?
          <CreateAccountFormSkeleton />
        : <CreateAccountForm onCancel={onClose} onSuccess={onSuccess} createSource={createSource} />}
      </Modal>
    </CreateAccountModalContextProvider>
  );
};
